import debug from 'debug';
import { useEffect } from 'react';
import GoogleAnalytics from 'react-ga';

const log = debug('pivot:analytics');

GoogleAnalytics.initialize('UA-119321074-2', {
  debug: false,
  titleCase: true,
  sampleRate: process.env.NODE_ENV === 'production' ? 100 : 0,
  forceSSL: true,
});

export default GoogleAnalytics;

export function useAnalytics(location) {
  useEffect(() => {
    log('Path: %s', location.pathname);
    GoogleAnalytics.pageview(location.pathname);
  }, [location.pathname]);
}
